import {Provider} from '@angular/core';

import {
  ListCitiesUseCaseProvider
} from '@features/setting/presentation/providers/list-cities/list-cities.use-case.provider';

import {ListCitiesFacade} from '@features/setting/presentation/facades/list-cities/list-cities.facade';

export const ListCitiesFacadeProvider: Provider[] = [
  ListCitiesUseCaseProvider,
  ListCitiesFacade
];
